import type { Match } from '@/types/api.types';

/**
 * Единый компаратор порядка боев для трансляции и Live Табло.
 * Не использовать id как основной ключ — он глобальный и ломает порядок на татами.
 */
export function compareMatchesForOrder(a: Match, b: Match): number {
  const na = a.matchNumber ?? 999999;
  const nb = b.matchNumber ?? 999999;
  if (na !== nb) return na - nb;
  const ra = a.round ?? 0;
  const rb = b.round ?? 0;
  if (ra !== rb) return ra - rb;
  const pa = a.position ?? 0;
  const pb = b.position ?? 0;
  if (pa !== pb) return pa - pb;
  return a.id - b.id;
}
